import { COMPONENT_TYPES, GROUP_TYPES, CONFIG_LAYOUTS, FIELD_TYPES } from "./constants.js";
import { COMPOSITE_FIELDS } from "./constants.js";
function isText(config) {
  return config.type === COMPONENT_TYPES.TEXT;
}
function isTextBlock(config) {
  return config.type === COMPONENT_TYPES.TEXT_BLOCK;
}
function isSemiCircle(config) {
  return config.type === COMPONENT_TYPES.SEMI_CIRCLE;
}
function isValue(config) {
  return config.type === COMPONENT_TYPES.VALUE;
}
function isTrendIndicator(config) {
  return config.type === COMPONENT_TYPES.TREND_INDICATOR;
}
function isTrendWithIcon(config) {
  return config.type === COMPONENT_TYPES.TREND_WITH_ICON;
}
function isIcons(config) {
  return config.type === COMPONENT_TYPES.ICONS;
}
function isTable(config) {
  return config.type === COMPONENT_TYPES.TABLE;
}
function isLineChart(config) {
  return config.type === COMPONENT_TYPES.LINE_CHART;
}
function isBarChart(config) {
  return config.type === COMPONENT_TYPES.BAR_CHART;
}
function isStackedBarChart(config) {
  return config.type === COMPONENT_TYPES.STACKED_BAR_CHART;
}
function isCustom(config) {
  return config.type === COMPONENT_TYPES.CUSTOM;
}
function isUnknownComponent(config) {
  return !isText(config) && !isTextBlock(config) && !isSemiCircle(config) && !isValue(config) && !isTrendIndicator(config) && !isTrendWithIcon(config) && !isIcons(config) && !isTable(config) && !isLineChart(config) && !isBarChart(config) && !isStackedBarChart(config) && !isCustom(config);
}
function isHeader(group) {
  return group.type === GROUP_TYPES.header;
}
function isCard(group) {
  return "type" in group && group.type === GROUP_TYPES.card;
}
function isContainer(group) {
  return "type" in group && group.type === GROUP_TYPES.container;
}
function isReportContent(group) {
  return isContainer(group) || isCard(group) || isHeader(group);
}
function isUnknownContainer(group) {
  return !isHeader(group) && !isCard(group) && !isContainer(group);
}
const isLiteralString = (val) => typeof val === "string";
const isTrTag = (val) => !!val && typeof val === "object" && "key" in val && typeof val.key === "string";
const isLtrTag = (val) => !!val && typeof val === "object" && "values" in val && typeof val.values === "object";
const isMdTag = (val) => !!val && typeof val === "object" && "isMarkdown" in val && val.isMarkdown === true && "key" in val && typeof val.key === "string";
const isCmsTag = (val) => !!val && typeof val === "object" && "isCmsContent" in val && val.isCmsContent === true && "key" in val && typeof val.key === "string";
const isReportConfig = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return Array.isArray(config) && config.every((item) => isReportContent(item));
};
const isConfig = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return config !== null;
};
const isConfigurationLayout = (val) => Object.values(CONFIG_LAYOUTS).includes(val);
const isConfiguration = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return config.id !== void 0 && (config.layout === void 0 || isConfigurationLayout(config.layout)) && config.report_endpoints !== void 0 && Array.isArray(config.report_endpoints) && config.report_endpoints.every((endpoint) => typeof endpoint === "object" && endpoint.uri !== void 0 && endpoint.method !== void 0 && (endpoint.params === void 0 || typeof endpoint.params === "object"));
};
const isHeroOverviewConfiguration = (val) => isConfiguration(val) && val.layout === CONFIG_LAYOUTS.HERO_OVERVIEW;
const isVariableTag = (val) => !!val && typeof val === "object" && "variable" in val && typeof val.variable === "string";
const isGoal = (goal) => typeof goal === "object" && goal !== null && "key" in goal && typeof goal.key === "string";
const isEndpoint = (value) => typeof value === "object" && value !== null && "uri" in value && "method" in value && typeof value.uri === "string" && typeof value.method === "string" && value.uri.length > 0 && value.method.length > 0;
const isDataset = (value) => typeof value === "object" && value !== null && "columns" in value && "data" in value && Array.isArray(value.columns) && Array.isArray(value.data);
const isDataWithEndpoint = (data) => typeof data === "object" && data !== null && "endpoint" in data && typeof data.endpoint === "object" && "uri" in data.endpoint && "method" in data.endpoint && typeof data.endpoint.uri === "string" && typeof data.endpoint.method === "string" && data.endpoint.uri.length > 0 && data.endpoint.method.length > 0;
const isDataWithDataset = (data) => typeof data === "object" && data !== null && !("endpoint" in data) && "columns" in data && "data" in data;
const isMainReportDataResponse = (data) => typeof data === "object" && data !== null && "data" in data && "meta" in data && typeof data.data === "object" && typeof data.meta === "object";
const isSubsequentReportDataResponse = (data) => typeof data === "object" && data !== null && "data" in data && "status" in data && typeof data.data === "object" && typeof data.status === "string" && ["done", "pending", "error"].includes(data.status);
const isDataSource = (data) => typeof data === "object" && data !== null && "sources" in data && typeof data.sources === "object" && Object.keys(data.sources).length > 0;
const isDataSourceDefinition = (data) => typeof data === "object" && data !== null;
const isParsedDataConfig = (data) => typeof data === "object" && data !== null && !("source" in data) && "key" in data && typeof data.key === "string";
const isParsedQuery = (data) => typeof data === "object" && data !== null && "id" in data && typeof data.id === "string" && data.id.length > 0;
const isSourceConfig = (val) => typeof val === "object" && val !== null && Object.keys(val).every((key) => {
  const source = val[key];
  return typeof source === "object" && source !== null && "query" in source && isParsedQuery(source.query);
});
const isFieldsConfig = (val) => {
  if (!val || typeof val !== "object") {
    return false;
  }
  const config = val;
  return config !== null && typeof config === "object" && !Array.isArray(config) && Object.keys(config).every((key) => {
    const field = config[key];
    return typeof field === "object" && field !== null && "type" in field && typeof field.type === "string" && ("options" in field ? Array.isArray(field.options) : true) && ("default" in field ? typeof field.default === "string" : true) && ("label" in field ? typeof field.label === "string" : true) && ("description" in field ? typeof field.description === "string" : true) && ("required" in field ? typeof field.required === "boolean" : true) && ("fallback" in field ? typeof field.fallback === "string" : true) && ("width" in field ? typeof field.width === "number" : true) && ("height" in field ? typeof field.height === "number" : true);
  });
};
const isField = (field) => {
  if (!field || typeof field !== "object") {
    return false;
  }
  const f = field;
  return "type" in f && typeof f.type === "string" && ("default" in f ? typeof f.default === "string" : true) && ("label" in f ? typeof f.label === "string" : true) && ("required" in f ? typeof f.required === "boolean" : true) && ("fallback" in f ? typeof f.fallback === "string" : true);
};
const isDateRange = (config) => config.type === FIELD_TYPES.dateRange;
const isSelect = (config) => config.type === FIELD_TYPES.select;
export {
  COMPONENT_TYPES,
  COMPOSITE_FIELDS,
  CONFIG_LAYOUTS,
  FIELD_TYPES,
  GROUP_TYPES,
  isBarChart,
  isCard,
  isCmsTag,
  isConfig,
  isConfiguration,
  isConfigurationLayout,
  isContainer,
  isCustom,
  isParsedDataConfig as isDataKey,
  isDataSource,
  isDataSourceDefinition,
  isDataWithDataset,
  isDataWithEndpoint,
  isDataset,
  isDateRange,
  isEndpoint,
  isField,
  isFieldsConfig,
  isGoal,
  isHeader,
  isHeroOverviewConfiguration,
  isIcons,
  isLineChart,
  isLiteralString,
  isLtrTag,
  isMainReportDataResponse,
  isMdTag,
  isParsedDataConfig,
  isParsedQuery,
  isReportConfig,
  isReportContent,
  isSelect,
  isSemiCircle,
  isSourceConfig,
  isStackedBarChart,
  isSubsequentReportDataResponse,
  isTable,
  isText,
  isTextBlock,
  isTrTag,
  isTrendIndicator,
  isTrendWithIcon,
  isUnknownComponent,
  isUnknownContainer,
  isValue,
  isVariableTag
};
